import React from 'react';

interface QuotesIconProps {
  color?: string;
}

const DEFAULT_COLOR = '#000000';

export const QuotesIcon: React.FC<QuotesIconProps> = ({ color }) => {
  return (
    <svg width="29px" height="26px" viewBox="0 0 29 26" version="1.1">
      <title>“</title>
      <desc>Created with Sketch.</desc>
      <g id="Testimonial" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Testimonial/long-copy" transform="translate(-684.000000, -179.000000)" fill={color || DEFAULT_COLOR}>
          <g id="Group-41" transform="translate(0.000000, 70.000000)">
            <g id="Group-3" transform="translate(653.000000, 77.000000)">
              <g id="Group-6">
                <path
                  d="M38.7678571,45.4321602 L43.4285714,45.4321602 L43.4285714,57.3571429 L31,57.3571429 L31,48.3328317 C31,38.4758711 35.1428157,33.1983133 43.4285714,32.5 L43.4285714,36.9718685 C40.321413,37.8044728 38.7678571,40.194817 38.7678571,44.1429729 L38.7678571,45.4321602 Z M55.3392857,45.4321602 L60,45.4321602 L60,57.3571429 L47.5714286,57.3571429 L47.5714286,48.3328317 C47.5714286,38.4758711 51.7142443,33.1983133 60,32.5 L60,36.9718685 C56.8928416,37.8044728 55.3392857,40.194817 55.3392857,44.1429729 L55.3392857,45.4321602 Z"
                  id="“"
                  transform="translate(45.500000, 44.928571) rotate(-360.000000) translate(-45.500000, -44.928571) "
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
